import { render, staticRenderFns } from "./selectProductType.vue?vue&type=template&id=3d605026&scoped=true"
import script from "./selectProductType.vue?vue&type=script&lang=js"
export * from "./selectProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d605026",
  null
  
)

export default component.exports